import React from 'react'

// Redux
import { connect } from 'react-redux'

// Firebase
import * as firebase from 'firebase';
import { DataLoader } from '@fibo-app/fibo-collab-shared';

class FirebaseUserManager extends React.Component {

  userMetadataLoader : DataLoader
  userTeamsLoader : DataLoader
  userRoomsLoader : DataLoader

  constructor(props : Object) {
    super(props);

    this.checkProps(undefined, props.userAuth);
  }

  componentWillReceiveProps(nextProps) {
    this.checkProps(this.props.userAuth, nextProps.userAuth);
  }

  checkProps(currUseAuth, nextUserAuth) {
    const currUserId = currUseAuth && currUseAuth.id
    const nextUserId = nextUserAuth && nextUserAuth.id

    // Same user, nothing to do
    if (currUserId === nextUserId) {
      return;
    }

    // Stop syncing current user info
    if (currUserId) {
      this.stopSyncingUser(currUserId);
      return;
    }

    // Start syncing next user info
    if (nextUserId) {
      this.startSyncingUser(nextUserId);
      return;
    }
  }

  startSyncingUser(userId : string) {
    this.userMetadataLoader = new DataLoader(firebase, 'users', 'metadata');
    this.props.dispatch(this.userMetadataLoader.startSyncing(userId));

    this.userTeamsLoader = new DataLoader(firebase, 'users', 'teams', true);
    this.props.dispatch(this.userTeamsLoader.startSyncing(userId));
  }

  stopSyncingUser(userId) {
    if (this.userMetadataLoader) {
      this.userMetadataLoader.stopSyncing();
      this.userMetadataLoader = undefined;
    }

    if (this.userTeamsLoader) {
      this.userTeamsLoader.stopSyncing();
      this.userTeamsLoader = undefined;
    }
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  return {
    userAuth: state.firebase.userAuth,
  }
};
export default connect(mapStateToProps)(FirebaseUserManager)



// WEBPACK FOOTER //
// ./src/infra/components/FirebaseUserManager.js